const meetingState = {
    data:{},
    isExtend:false
}

export default meetingState